import { ApiType } from "@gymflow/common";
import { DetailedInvoiceDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useMemberInvoiceAsMember(
  {
    api,
    invoiceNumber,
  }: {
    api: ApiType;
    invoiceNumber?: string;
  },
  queryOpts?: Omit<UseQueryOptions<DetailedInvoiceDTO>, "queryKey">,
) {
  return useQuery({
    queryKey: memberAsMemberQueryKeys.invoice(invoiceNumber),
    queryFn: async () => {
      return (await api.profileApi.getInvoiceByInvoiceNumber(invoiceNumber!))
        .data;
    },
    enabled: !!invoiceNumber,
    ...queryOpts,
  });
}
